import React from "react";
import StoreContext from './../../../Store/Context';
import { NavLink as RRNavLink } from "react-router-dom";
import { NavItem, Navbar, Nav, NavLink, Row, Col, Container } from "reactstrap";
import { LOGO_SCHOOL } from "../../Constants/SrcImages";
import "../../../www/css/style.css";
interface IAdminState{
  children:any;
}
interface IAdminProps {
  children:any;
}
class LayoutAdmin extends React.Component<IAdminProps, IAdminState>{
  static contextType = StoreContext
  constructor(props: IAdminProps) {
    super(props);
    this.state = {
      children:props.children
    };
  }

  updateTokens = () => {
    const test = this.context
    test.quitToken()
  };

  render() {
    return (
      <React.Fragment>
        <Container className="themed-container" fluid={true}>
          <Row>
            <Col sm={2}>
              <Row>
                <Navbar>
                  <Nav tabs>
                    <NavItem className="text-center w-100">
                      <NavLink>
                        <img className="img-logo m-auto" src={LOGO_SCHOOL} alt="" />
                      </NavLink>
                    </NavItem>  
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/home" activeClassName="active">
                        Personas
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/announcement" activeClassName="active">
                      Anuncios
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/password" activeClassName="active">
                        Contraseñas
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/grades" activeClassName="active">
                        Grados
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/registration" activeClassName="active">
                        Matriculas
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/boletin" activeClassName="active">
                        Boletines
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink  tag={RRNavLink} to="/admin/hour" activeClassName="active">
                        Horarios
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/retired" activeClassName="active">
                        Retirados
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/setup" activeClassName="active">
                        Año lectivo
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/activation" activeClassName="active">
                        Activaciones
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/cycles" activeClassName="active">
                        Ciclos
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/plans" activeClassName="active">
                        Planes
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink  tag={RRNavLink} to="/admin/area-by-cycle" activeClassName="active">
                        Areas por ciclo
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/subjects" activeClassName="active">
                        Materias
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink  tag={RRNavLink} to="/admin/subject-by-plan" activeClassName="active">
                        Materias por plan
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/a-consejeria" activeClassName="active">
                        Asignar consejeria
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/a-subject" activeClassName="active">
                        Asignar materias
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/teachers" activeClassName="active">
                        Profesores
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/admin/cuentas" activeClassName="active">
                        Cuentas
                      </NavLink>
                    </NavItem>

                    <NavItem className="text-center w-100"  onClick={()=> this.updateTokens()} >
                      <NavLink>
                        Salir
                      </NavLink>
                    </NavItem>
            
                  </Nav>
                </Navbar>
              </Row>
            </Col>
            <Col sm={10}>{this.props.children}</Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default LayoutAdmin;